import React from "react";
import classes from "./DownloadCoursefinder.module.scss";
import CustomImage from "../../CustomImage";
import GetItOnGooglePlay from "../../UI/Icons/GetItOnGooglePlay";
import GetItOnAppleStore from "../../UI/Icons/GetItOnAppleStore";

interface DownloadCoursefinderProductImg {
  url: string;
  alternativeText?: string;
}

interface DownloadCoursefinderData {
  id: number;
  title: string;
  description: string;
  productImg?: DownloadCoursefinderProductImg;
}

interface Props {
  downloadCoursefinderData?: DownloadCoursefinderData;
  googlePlayHref?: string;
  appStoreHref?: string;
}

const DownloadCoursefinder = ({
  downloadCoursefinderData,
  googlePlayHref = "https://play.google.com/store/apps/details?id=kc.coursefinder.ai",
  appStoreHref = "https://apps.apple.com/ph/app/coursefinder-ai/id6473614202",
}: Props) => {
  if (!downloadCoursefinderData) return null;

  const { title, description, productImg } = downloadCoursefinderData;

  return (
    <section className={classes["download-coursefinder-container"]}>
      <div className={classes["section-wrapper"]}>
        <div className={classes.content}>
          {title && <h2 className={classes.heading}>{title}</h2>}
          {description && <div className={classes.subtext} dangerouslySetInnerHTML={{ __html: description }} />}

          <div className={classes["badges-row"]}>
            <a href={googlePlayHref} target="_blank" rel="noopener noreferrer" className={classes.badge}>
              <GetItOnGooglePlay />
            </a>
            <a href={appStoreHref} target="_blank" rel="noopener noreferrer" className={classes.badge}>
              <GetItOnAppleStore />
            </a>
          </div>
        </div>

        {productImg?.url && (
          <div className={classes["image-wrapper"]}>
            <CustomImage
              src={productImg.url}
              alt={productImg.alternativeText || title}
              width={460}
              height={480}
              objectFit="contain"
              className={classes["product-image"]}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default DownloadCoursefinder;
